module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-185.f80a1844.svg";